import { Skeleton } from '@packages/shared/src/ui/Skeleton/Skeleton';

export const MiniDVSkeleton = () => (
  <>
    <div className="grid grid-cols-1 overflow-y-auto md:min-w-[800px] md:grid-cols-2">
      <div className="relative p-2">
        <div className="absolute top-5 right-0 bottom-5 z-10 hidden w-px bg-gray-300 md:block" />
        <div className="flex flex-row items-start gap-2 md:flex-col">
          <Skeleton className="h-[250px] w-full" />
          <div className="flex w-full flex-col gap-1.5">
            <Skeleton className="h-2.5 md:h-4" />
            <Skeleton className="h-2.5 w-[200px] md:h-4" />
            <Skeleton className="h-2.5 w-[100px] md:h-4" />
            <Skeleton className="h-2.5 w-[100px] md:h-4" />
            <div className="flex flex-row gap-1">
              <Skeleton className="h-4 w-5 md:h-5" />
              <Skeleton className="h-4 w-[80px] md:h-5" />
              <Skeleton className="h-4 w-5 md:h-5" />
            </div>
          </div>
        </div>
        <Skeleton className="mt-2 h-4.5" />
      </div>
      <div className="p-2">
        <div className="flex flex-col gap-4">
          <Skeleton className="h-[80px]" />
          <Skeleton className="h-[80px]" />
          <Skeleton className="h-[80px]" />
          <Skeleton className="h-[80px]" />
        </div>
      </div>
    </div>
    <div className="m-2 flex h-4.5 justify-end">
      <Skeleton className="h-4.5 w-[230px]" />
    </div>
  </>
);
